<template>
  <f7-page name="ccm-matchbook-study" class="page-bg-render">
    <f7-navbar>
			<f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <div class="title">
        스마트북 학습
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="right"></f7-link>
      </f7-nav-right>
    </f7-navbar>

		<div style="padding:8px;">
			<button class="button button-outline float-right" style="width:unset; line-height: 1;" @click="addSmartBook()">
				<i class="f7-icons" style="vertical-align:middle">plus</i>
				<span style="vertical-align:middle"> 스마트북 등록</span>
			</button>
		</div>

    <f7-block-title>
			<span>등록된 스마트북 목록</span>
		</f7-block-title>
		<div class="list media-list">
			<ul>
				<li>
					<a href="#" class="item-link item-content" @click="showMBPageExamNoSheetModal('B3M')">
						<div class="item-media"><img :src="bookImageUrl(0)"/></div>
						<div class="item-inner">
							<div class="item-title-row">
								<div class="item-title">스마트북 제목 1</div>
								<div class="item-after">학습하기</div>
							</div>
							<div class="item-subtitle">중1-1</div>
							<div class="item-text">
								<simple-progress value-title="14. 문제지 제목" :unit-count=20 :start-percent=11 :end-percent=19></simple-progress>
							</div>
						</div>
					</a>
				</li>
				<li>
					<a href="#" class="item-link item-content" @click="showMBPageExamNoSheetModal('B4M')">
						<div class="item-media"><img :src="bookImageUrl(0)"/></div>
						<div class="item-inner">
							<div class="item-title-row">
								<div class="item-title">스마트북 제목 2</div>
								<div class="item-after">학습하기</div>
							</div>
							<div class="item-subtitle">중1-1</div>
							<div class="item-text">
								<simple-progress value-title="15. 문제지 제목" :unit-count=20 :start-percent=0 :end-percent=79></simple-progress>
							</div>
						</div>
					</a>
				</li>
				<li>
					<a href="#" class="item-link item-content" @click="showMBPageExamNoSheetModal('B5M')">
						<div class="item-media"><img :src="bookImageUrl(0)"/></div>
						<div class="item-inner">
							<div class="item-title-row">
								<div class="item-title">스마트북 제목 3</div>
								<div class="item-after">학습하기</div>
							</div>
							<div class="item-subtitle">중1-1</div>
							<div class="item-text">
								<simple-progress value-title="16. 문제지 제목" :unit-count=20 :start-percent=11 :end-percent=29></simple-progress>
							</div>
						</div>
					</a>
				</li>
			</ul>
		</div>

		<div class="sheet-modal sheet-modal-top mb-page-exam-no-modal" style="height:80%;">
			<div class="toolbar toolbar-bottom">
				<div class="toolbar-inner">
					<div class="left"><a class="link text-color-red" href="#" @click="removeMatchBookRegist()">스마트북 등록 해제</a></div>
					<div class="right"><a class="link sheet-close text-color-primary" href="#">닫기</a></div>
				</div>
			</div>
			<div class="sheet-modal-inner">
				<div class="page-content">
					<div class="list">
						<ul>
							<li style="background-color:#f0f0f0;">
								<div class="item-content item-inner">
									<div class="item-title">
										<p style="margin: 0;">스마트북 코드 : <b>{{selectedBookCode}}</b></p>
										<p style="margin: 0;">스마트북 이름 : <b>{{selectedBookName}}</b></p>
									</div>
								</div>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>1. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>2. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>3. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>4. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>5. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>6. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>7. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>8. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>9. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>10. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>11. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>12. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>13. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-gray">결과보기</span>
										</div>
									</div>
								</a>
							</li>
							<li>
								<a href="#" class="item-link" @click="startMatchPaper('S5M')">
									<div class="item-content item-inner">
										<div class="item-title">
											<div class="item-header">스마트북 문제지 코드 : S5M-E4T</div>
											<span>14. 기출문제 제목 1</span>
										</div>
										<div class="item-after">
											<span class="badge color-orange">문제풀기</span>
										</div>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
				<div class="block" style="height:var(--f7-toolbar-height);">&nbsp;<!-- 툴바만큼 height 확보 --></div>
			</div>
		</div>
  </f7-page>
</template>

<script>
import { f7 } from 'framework7-vue';
import MODULE from '../../../js/common/module';
import Vue from 'vue';
import PAGES from '../../../js/pages';
import CONST from '../../../js/common/constant';
import API from '../../../js/common/api';

import SimpleProgress from '../../../components/progress/simple-progress.vue';

export default {
	components: {
		SimpleProgress
	},
  data() {
    return {
			selectedBookCode: "",
			selectedBookName: "",
			selectedMatchBookData: {
        sheet: undefined,
        startPageNo: 1,
        startExamNo: 1,
        endPageNo: 1,
        endExamNo: 1
      },
      bookList: []
    }
	},
  mounted() {
		// this.loadCourseHomeworkList();
    //$(document).on('page:init page:reinit', '.page[data-name="ccm-put-list"]', this.onPageShow);
	},
  methods: {
    onPageShow(e) {
      
		},
		addSmartBook() {
			this.$f7.dialog.prompt('등록할 스마트북 코드 입력.', "안내", function (code) {
				if (MODULE.Util.isEmpty(code)) {
					MODULE.DialogBox.message("코드를 입력하세요.");	
				}

				MODULE.DialogBox.message(code + "를 등록합니다.");
			});
		},
		bookImageUrl(bookImageNo) {
			return CONST.contentServerUrl + "/websvr/contents/common/matchbookimage/d4-01/d2-00/bi-10001/10001-bookimage.png";
		},
		homeworkClick(itemIndex) {
			var _this = this;

			var item = this.putList[itemIndex];
		},
    loadCourseHomeworkList() {
      var _this = this;
		},
		onChangeStepper() {
      const stepperStartPageNo = this.$refs.startPageNo.f7Stepper;
      const stepperStartExamNo = this.$refs.startExamNo.f7Stepper;
      const stepperEndPageNo = this.$refs.endPageNo.f7Stepper;
      const stepperEndExamNo = this.$refs.endExamNo.f7Stepper;

      if (stepperStartPageNo.value == stepperEndPageNo.value) {
        if (stepperEndExamNo.value < stepperStartExamNo.value) {
          stepperEndExamNo.setValue(stepperStartExamNo.value);
        }
      } else if (stepperStartPageNo.value > stepperEndPageNo.value) {
        stepperEndPageNo.setValue(stepperStartPageNo.value);
        stepperEndExamNo.setValue(stepperStartExamNo.value);
      }

      this.selectedMatchBookData.startPageNo = stepperStartPageNo.value;
      this.selectedMatchBookData.startExamNo = stepperStartExamNo.value;
      this.selectedMatchBookData.endPageNo = stepperEndPageNo.value;
      this.selectedMatchBookData.endExamNo = stepperEndExamNo.value;
    },
    showMBPageExamNoSheetModal(itemIndex) {
			// sheet 는 열때마다 생성, 닫을때 제거해야 정상 동작 한다.

			/* 실데이터에서만 정상 동작
			var item = this.bookList[itemIndex];

			this.selectedBookCode = item.MATCHBOOK_CODE;
			this.selectedBookName = item.MATCHBOOK_NAME;
			*/

			this.selectedBookCode = "S5M";
			this.selectedBookName = "생각수학 A-1";

			if (this.selectedMatchBookData.sheet == undefined) {
				this.selectedMatchBookData.sheet = f7.sheet.create({
					el: '.mb-page-exam-no-modal',
					swipeToClose: false,
					swipeToStep: false,
					backdrop: true
				});
			}
			
			this.selectedMatchBookData.sheet.open();
		},
		startMatchBookApplyButtonClick() {
      var startPageNo = this.selectedMatchBookData.startPageNo;
      var startExamNo = this.selectedMatchBookData.startExamNo;
      var endPageNo = this.selectedMatchBookData.endPageNo;
      var endExamNo = this.selectedMatchBookData.endExamNo;

      if (
        (startPageNo == endPageNo && startExamNo <= endExamNo) ||
        (startPageNo < endPageNo)
      ) {

				this.selectedMatchBookData.sheet.close();
				
				var url = PAGES.SUB_CCM_MATCHBOOK_APPLY;
        var param = {
          code: this.code,
          startPageNo: startPageNo,
          startExamNo: startExamNo,
          endPageNo: endPageNo,
          endExamNo: endExamNo,
          studyKey: undefined
        }
        PAGES.popPage(url, param);
      }
		},
		removeMatchBookRegist() {
			var selectedBookName = this.selectedBookName;

			MODULE.DialogBox.message("매칭북 : " + selectedBookName + " 를 등록 해제 할까요 ?");
		}
  }
}

</script>